import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class SurveyLogo extends React.PureComponent {
    static propTypes = {
        data: PropTypes.object,
    };

    render() {
        const { data } = this.props;

        return (
            <div className={styles.box}>
                <div className={styles.logo} />
                <div className={styles.people}>
                    <span>{`${data?.count}人参与 `}</span>
                    <span>{data?.surveyinfo?.expire === '0' ? '抱歉，本调查已经结束' : '投票进行中'}</span>
                </div>
            </div>
        );
    }
}

export default SurveyLogo;
